export const getDefaultChargeType = (
  activeTab: string | undefined,
  chargeType: { labelEng?: string | null; value?: string | null }[],
): string | undefined => {
  if (!activeTab) return undefined;

  return chargeType.find((item) => item.labelEng?.toLowerCase() === activeTab.toLowerCase())?.value ?? undefined;
};
